import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers';
import { ReportFieldEnum } from 'Common/FieldEnum';
import { ReportGeneration } from 'Common/ObjectHelper';
import { STUDENT_ALLERGIES_FORM_NAME } from 'Common/FormEnum';
import { createToast, toastType } from 'Common/ToastHelper';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';

import {
  getAllergenAction,
  getAllergenReportAction,
  getAllergenReportExcel,
  clearReportDataAction,
  getTeachersAction,
} from './state/actions';
import StudentAllergiesForm from './components/StudentAllergiesForm';

class StudentAllergiesContainer extends Component {
  state = {
    disabled: false,
  };

  componentDidMount() {
    this.props.getAllergenAction();
  }

  componentDidUpdate(prevProps) {
    const { report, reportError, clearReportDataAction } = this.props;

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'AllergenReport');
      }

      clearReportDataAction();
    }

    if (reportError && !prevProps.reportError) {
      if (reportError[0].Title === null) {
        createToast(toastType.error, 'Error', 'Unable to view report', true);
      } else {
        createToast(
          toastType.error,
          reportError[0].Title,
          reportError[0].Message,
          true
        );
      }

      clearReportDataAction();
    }
  }

  formSubmit = values => {
    const model = {
      siteId: values[ReportFieldEnum.Site],
      teacher: values[ReportFieldEnum.Teacher],
      gradeId: values[ReportFieldEnum.Grade],
      allergenId: values[ReportFieldEnum.Allergen],
      [ReportFieldEnum.ReportFormat]: values[ReportFieldEnum.ReportFormat],
    };

    if (values[ReportFieldEnum.ReportFormat] === reportFormatEnum.PDF) {
      this.props.getAllergenReportAction(model);
    } else {
      this.props.getAllergenReportExcel(model);
    }
  };

  getMainProps = () => {
    const { reportFetching, fieldsLoading } = this.props;

    return {
      toolbox: {
        formName: STUDENT_ALLERGIES_FORM_NAME,
        saveButtonProps: {
          content: 'View',
          disabled: reportFetching || fieldsLoading,
          loading: reportFetching,
        },
        shown: true,
      },
    };
  };

  render() {
    const {
      fieldsLoading,
      allergens,
      teachers,
      grades,
      reportFetching,
    } = this.props;

    return (
      <Fragment>
        <Filter title={'Student Allergies'} />
        <Main {...this.getMainProps()}>
          <StudentAllergiesForm
            onSubmit={this.formSubmit}
            siteChange={site => this.props.getTeachersAction(site)}
            teachers={teachers || []}
            grades={grades || []}
            disabled={reportFetching || fieldsLoading}
            loading={fieldsLoading}
            allergens={allergens || []}
            initialValues={{
              [ReportFieldEnum.ReportFormat]: reportFormatEnum.PDF,
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ StudentAllergiesState }) => {
  return {
    teachers: StudentAllergiesState.teachers,
    grades: StudentAllergiesState.grades,
    fieldsLoading: StudentAllergiesState.fieldsLoading,
    allergens: StudentAllergiesState.allergens,
    reportFetching: StudentAllergiesState.reportFetching,
    report: StudentAllergiesState.allergenReport,
    reportError: StudentAllergiesState.allergenReportError,
  };
};

const mapDispatchToProps = {
  getAllergenAction,
  getAllergenReportAction,
  clearReportDataAction,
  getTeachersAction,
  getAllergenReportExcel,
};

export const StudentAllergies = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(StudentAllergiesContainer)
);



// WEBPACK FOOTER //
// ./src/pages/studentallergies/StudentAllergies.js